/**
 * ADMIN ROUTE v2.0 - ULTRA OPTIMIZED
 * ✅ React.memo en componentes
 * ✅ useCallback para handlers
 * ✅ Componentes extraídos y optimizados
 */
import { memo, useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = memo(function AdminRoute({ children }) {
  const { user, isAdmin, loading } = useAuth();

  // Loading state
  if (loading) {
    return <LoadingState />;
  }

  // Not authenticated
  if (!user) {
    console.log('⚠️ No autenticado, redirigiendo a home');
    return <Navigate to="/" replace />;
  }

  // Not admin
  if (!isAdmin) {
    console.log('⚠️ No es admin, acceso denegado');
    return <AccessDenied />;
  }

  // Admin verified
  console.log('✅ Admin verificado, permitiendo acceso');
  return children;
});

// ✅ COMPONENTES MEMOIZADOS

const LoadingState = memo(function LoadingState() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto mb-4" />
        <p className="text-gray-400">Verificando permisos...</p>
      </div>
    </div>
  );
});

const AccessDenied = memo(function AccessDenied() {
  const handleGoHome = useCallback(() => {
    window.location.href = '/';
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center max-w-md mx-auto p-6">
        <div className="text-6xl mb-4">🚫</div>
        <h2 className="text-2xl font-bold text-white mb-2">
          Acceso Denegado
        </h2>
        <p className="text-gray-400 mb-6">
          No tienes permisos de administrador para acceder a esta página.
        </p>
        <button
          onClick={handleGoHome}
          className="bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700 transition-colors active:scale-95"
        >
          Volver al Inicio
        </button>
      </div>
    </div>
  );
});

export default AdminRoute;